import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ShieldCheck } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-slate-900 text-white py-12" data-id="element-77">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-emerald-600/20 blur-[120px] rounded-full pointer-events-none" data-id="element-78" />

      <div className="max-w-3xl mx-auto px-6 relative z-10 w-full" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center flex flex-col items-center" data-id="element-80">
          <div className="inline-block px-4 py-1.5 rounded-full bg-slate-800 border border-slate-700 text-emerald-400 font-semibold text-xs md:text-sm mb-4" data-id="element-81">
            KIT Recruiter PRO™
          </div>

          <h1 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold leading-tight mb-5 text-white" data-id="element-82">
            DEJA DE IMPROVISAR EN TUS PROCESOS DE SELECCION
          </h1>

          {/* Mockup — placed right below the H1, enlarged 20% (w-48 -> w-[14.4rem], w-60 -> w-72) */}
          <motion.img initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} onClick={() => {
          const el = document.getElementById('comprar');
          if (el) el.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }} whileHover={{
          scale: 1.04,
          y: -4
        }} src="https://cdn.magicpatterns.com/uploads/g4gcfvFobGNw5i73vrTtZW/Diseno_sin_titulo_(27).png" alt="KIT Recruiter PRO - Mockup del producto" className="w-[14.4rem] md:w-72 h-auto cursor-pointer drop-shadow-2xl mb-5" data-id="element-83" />

          <p className="text-lg md:text-xl text-slate-300 font-medium mb-3" data-id="element-84">
            Ordená, filtrá y seleccioná candidatos en la mitad del tiempo.
          </p>

          <p className="text-sm md:text-base text-slate-400 mb-6 max-w-2xl" data-id="element-85">
            El sistema práctico para recruiters, selectores y profesionales de
            RRHH que quieren gestionar búsquedas con más claridad.
          </p>

          <div className="flex flex-col items-center space-y-3 w-full" data-id="element-86">
            <CTAButton data-id="element-87" />
            <div className="flex items-center text-xs md:text-sm text-slate-400 font-medium" data-id="element-88">
              <ShieldCheck className="w-4 h-4 mr-2 text-emerald-500" data-id="element-89" />
              Acceso inmediato · Pago único y seguro
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}